import { ref, computed } from 'vue';
import { ALL_QUEUE_ID } from '@/enum/queueDashboardStatistics';

export function useEntitiesFilter(widgetConfig, parameterName = '{|queue_list|}' ) {

    const valueJson = computed(() => {
        const foundItem = widgetConfig.value.find(el => el.ParameterName === parameterName);
        return foundItem ? foundItem.WidgetParameterValueJson : null;
    });

    const entitiesFilter = (entities, key = 'queue_id') => {
        if (valueJson.value) {
            const entityPositive = valueJson.value['EntityPositive'] || [];
            const entityNegative = valueJson.value['EntityNegative'] || [];

            if (entityPositive && entityPositive.length) {
                return entities.filter(e =>
                    entityPositive.includes(e[key]) ||
                    (key === 'queue_id' && e[key] === ALL_QUEUE_ID)
                );
            } else if (entityNegative && entityNegative.length) {
                return entities.filter(e => !entityNegative.includes(e[key]));
            }
        }
        return entities;
    };

    return {
        entitiesFilter,
    };
}
